import React, { useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import SearchSelector from '../search-selector/';
import { connect } from 'react-redux';
import * as Actions from '../../redux/actions/';
import { getUsers } from "../../api/";

const UserSelector = ({label, onChange, onDeselect, onSelect, setUsers, userData, users, zIndex}) => {
	const [foundUsers, setFoundUsers] = useState();
	const [isSelected, setIsSelected] = useState(false);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		if (userData && userData.name) {
			setIsSelected(true);
		} else {
			setIsSelected(false);
		}

	}, [userData]);

	useEffect(() => {
		if (userData && userData.name === '') {
			setIsSelected(false);
		}
	}, [userData]);

	useEffect(() => {
		async function fetchUsers () {
			if (!users.length) {
				setIsLoading(true);
				const appUsers = await getUsers();

				setUsers(appUsers && appUsers.data);
			} else {
				setFoundUsers(users);
				setIsLoading(false);
			}
		}

		fetchUsers();

	}, [setUsers, users]);


	function handleInputChange (val) {
		onChange && onChange(val);
	}

	const handleUserSearch = (val) => {
		setFoundUsers(users.filter((user) => {
			return user.name.toUpperCase().indexOf(val.toUpperCase()) > -1;
		}));
	}

	const handleUserSelect = (val) => {
		console.log('user selected', val);
		//const selectedAlbumObj = getAlbum(val);
		onSelect && onSelect(val);
		setIsSelected(true);
  }

	const handleUserDeselect = (userName) => {
		onDeselect(userName);
		setIsSelected(false);
		setFoundUsers(users);
  }

	return (
		<>
			<SearchSelector
				items={foundUsers}
				fieldIdentifier="User"
				label={label}
				onChange={handleInputChange}
				onSearch={handleUserSearch}
				onSelect={handleUserSelect}
				onDeselect={handleUserDeselect}
				assistiveText={{
					noResults: userData ? `No users found for ${userData.name}.` : null
				}}
				isSelected={isSelected}
				zIndex={zIndex}
				value={userData}
				isLoading={isLoading}
				loadingText="Loading Users..."
			/>
		</>
	)
};

UserSelector.propTypes = {
	disabled: PropTypes.bool,
	label: PropTypes.string,
	onDeselect: PropTypes.func,
	onSelect: PropTypes.func,
	userData: PropTypes.object,
	users: PropTypes.array,
	zIndex: PropTypes.string
};

const mapStateToProps = state => {
	return {
		users: state.users
  }
}

const mapDispatchToProps = {
	setUsers: Actions.setUsers
};

export default connect(mapStateToProps, mapDispatchToProps)(UserSelector);
